module.exports = __webpack_public_path__ + "static/media/bubble-1-tablet.c6e1d810.svg";